/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import CanvaIcon from "assets/icons/canva.svg";
import "./CanvaTrigger.scss";

export default function CanvaTrigger({ onClick, ...restProps }) {
  return (
    <a
      {...restProps}
      className={cn("canva-trigger scope-24f6a37c", restProps.className)}
      href="#"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick();
      }}
      data-testid="canva-trigger"
    >
      <CanvaIcon className="canva-trigger__icon scope-24f6a37c" data-testid="canva-trigger-icon" />
    </a>
  );
}
